import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  //<React.StrictMode>
    <App />
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Service Workerの登録
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // 初回インストール時は clients.claim() でも controllerchange が発火するため、
    // 「もともと Service Worker に制御されていたか」で世代交代かどうかを判別する
    const hadController = !!navigator.serviceWorker.controller;
    let reloading = false;

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!hadController || reloading) return;
      reloading = true;
      window.location.reload();
    });

    navigator.serviceWorker.register('/service-worker.js', { updateViaCache: 'none' })
      .then(registration => {
        const promptUpdate = (worker: ServiceWorker) => {
          if (window.confirm('新しいバージョンが利用可能です。更新しますか？')) {
            // 新しい Service Worker に交代を指示する。
            // 交代が完了すると controllerchange が発火し、上のハンドラがリロードする。
            worker.postMessage({ type: 'SKIP_WAITING' });
          }
        };

        // 前回キャンセルされて待機したままの Service Worker があれば再度案内する
        if (registration.waiting && navigator.serviceWorker.controller) {
          promptUpdate(registration.waiting);
        }

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              promptUpdate(newWorker);
            }
          });
        });

        // 定期的な更新チェック
        setInterval(() => {
          registration.update();
        }, 1000 * 60 * 60 * 1); // 1時間ごと
      })
      .catch(error => {
        console.error('Service Worker の登録に失敗:', error);
      });
  });
}
